import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SolarPanelAbrasionTester = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F2.png?alt=media&token=fb815f3d-bb7c-4125-a247-d79e6ceaf17e',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F2.png?alt=media&token=fb815f3d-bb7c-4125-a247-d79e6ceaf17e'
    ];

    return (
        <Layout>
            {/* Breadcrumb */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/rubber-polymer-industries">Rubber & Polymer Industries</a></li>
                </ul>
            </div>

            {/* Title */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Solar Panel Abrasion Tester</h1>
                </div>
            </div>

            {/* Main Section */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* Image Slider */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="DIN Abrasion Tester" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Solar Panel Abrasion Tester</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Conform to Standards: BS EN 1096 – 2
                                    Portable Pencil hardness tester
                                    According to Wolff Wilborn standard, this tester is designed to measure the coating surface
                                    hardness scrape-resistance, applied to experiment analysis or control production quality,
                                    suitable products including oil painting, furniture, car, cell phone, notebook, language translator,
                                    digital camera, etc. It is fast and easy to test single or double layer baking varnish. <br />
                                    <strong>Conform to Standards :</strong> ASTM D3363, ECCA T4 , MIL C27 227 , NEW 5350 , SIS 184187, SNV 37113,
                                    JIS C3003/D0202 <br />
                                    <strong>Applicable Industries:</strong> Plastic Industry, Electronics Industry, Optics Industry

                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Solar Panel Abrasion Tester"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default SolarPanelAbrasionTester